import {useState, useMemo} from 'react'
import styled from 'styled-components'
import {
  Button, Text, Dialog, Card, Icon, Flex, Box, TextField, TextButton, Slider
} from '@binance/uikit'
import {SETTING, LOGIN_PRURL, REGISTER_URL} from 'constants'
import useSymbolInfo from 'hooks/useSymbolInfo'
import useLeverageData from 'hooks/useLeverageData'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import {findCurLeverageByLevel} from 'utils/futures'
import {formatInteger} from 'utils/format'

const {leverageInfo} = SETTING

const MessageBoxWrap = styled(Card)`
  align-items: center;
  border-radius: 3px;
  color: #848e9c;
  background-color: #2a2f37;

  .close-icon {
    position: absolute;
    right: -40px;
    top: -8px;
    padding: 7px 10px;
    cursor: pointer;
    font-weight: 600;
  }

  .adjust-leverage-con {
    > div {
      height: 100%;
      margin: 0;
      padding: 4px 88px;
      background: #48515D;

      > div {
        background: #48515D;

        input, div {
          font-size: 26px;
          color: #fff;
        }
      }
    }
  }

  .not-login {
    border: 1px solid #48515D;
    border-radius: 3px;
    background: rgba(255, 255, 255, 0.04);
    padding: 10px 0;
    margin-top: 95px;
    line-height: 17px;
    justify-content: center;

    div {
      color: #848E9C;
    }
  }

  @media only screen and (max-width: 414px) {
    .close-icon {
      top: 4px;
      right: 20px;
    }
  }
`

export default function TransferDialog (props) {
  const {onClose, i18n} = props
  const isLogin = useUserLoginStatus()
  const {symbolInfo} = useSymbolInfo()
  const {quoteAsset, lng} = symbolInfo
  const {leverageData, updateLeverage} = useLeverageData(i18n)
  const {curLeverage, userNotionalValue, userCurLeverage} = leverageData
  const [selectLeverage, setSelectLeverage] = useState(curLeverage)
  const {bracket_notional_cap: nationalVal, maxLeverage} = userCurLeverage

  return useMemo(
    () => (
      <Dialog visible={true}>
        <MessageBoxWrap width={416}>
          <div className="close-icon" onClick={onClose}>
            <Icon color="#fff" hover="#A9B0BA" size={16} name="close1" />
          </div>
          <Text.Base
            width="100%"
            mt={32}
            fontSize={22}
            fontWeight={500}
            textAlign="center"
          >
            {i18n.AdjustLeverageTitle || 'Adjust Leverage'}
          </Text.Base>
          <Box className="content-box" width={352} mb={32}>
            <Box mt={24}>
              <Text.Caption style={{fontSize: '14px'}}>
                {i18n.LeverageLabel || 'Leverage'}
              </Text.Caption>
            </Box>
            <Flex width="100%" mt={3} className="adjust-leverage-con">
              <Button ml={0} mr={4} height={40} width={40} style={{background: '#48515D'}}
                disabled={selectLeverage === leverageInfo.minVal}
                onClick={() => setSelectLeverage(Math.max(selectLeverage - 1, leverageInfo.minVal))}>
                <Icon color="#C4C4C4" hover={
                  selectLeverage > leverageInfo.minVal ? '#F0B90B' : '#C4C4C4'
                } size={18} name="icon_subtract" />
              </Button>
              {/* <Text.Base width="75%" fontSize={26} style={{background: '#48515D', lineHeight: '40px'}} textAlign="center">
                {selectLeverage}{leverageInfo.symbol}
              </Text.Base> */}
              <TextField
                value={selectLeverage}
                onKeyPress={e => /[^\d]/.test(e.key) && e.preventDefault()}
                handleChange={e => {
                  let ipt = Number(e.target.value)
                  ipt = ipt >= maxLeverage ? maxLeverage
                    : ipt <= leverageInfo.minVal ? leverageInfo.minVal : ipt
                  setSelectLeverage(ipt)
                }}
                before=""
                after={<Text.Caption>{leverageInfo.symbol}</Text.Caption>}
                style={{textAlign: 'right', width: '42px'}}
              />
              <Button ml={4} height={40} width={40} bg="#F0B90B" style={{background: '#48515D', fontSize: '18px'}}
                disabled={selectLeverage === maxLeverage}
                onClick={() => setSelectLeverage(Math.min(selectLeverage + 1, maxLeverage))}>
                <Icon color="#C4C4C4" hover={
                  selectLeverage < maxLeverage ? '#F0B90B' : '#C4C4C4'
                } size={18} name="add" />
              </Button>
            </Flex>
            <Flex width="95%" mt={28} mb={36}>
              <Slider
                color="#F0B90B"
                bgColor="#48515d"
                pointColor="#656d7b"
                progress={selectLeverage}
                changedProgress={selectLeverage}
                onChange={setSelectLeverage}
                stepSize={5}
                unit={leverageInfo.symbol}
                range={{min: leverageInfo.minVal, max: leverageInfo.maxVal}}
                availableRange={{min: leverageInfo.minVal, max: maxLeverage}}
                showScales={true}
              />
            </Flex>
            {
              selectLeverage > 2
              && <Text.Base width="100%" fontSize={14} mt={3} color="#848E9C">
                · {i18n.AvailablePositionsTip || 'Available positions up to'} <span style={{color: '#F0B90B'}}>
                  {formatInteger(findCurLeverageByLevel(selectLeverage).bracket_notional_cap)}</span> {quoteAsset}
              </Text.Base>
            }
            {
              isLogin ? <>
              {
                userNotionalValue >= leverageInfo.minNationalVal
                && <Text.Base width="100%" fontSize={14} mt={3} color="#848E9C" lineHeight='18px'>
                · {i18n.positionPlusOpenOrders || 'Positions + open orders'} <span style={{color: '#F0B90B'}}>
                    {formatInteger(nationalVal)}
                  </span> {quoteAsset}, {i18n.biggestLeverageIs || 'your biggest leverage is'}
                  <span style={{color: '#F0B90B'}}> {maxLeverage}{leverageInfo.symbol}</span>
                </Text.Base>
              }
              <Flex mt={16}>
                <Text.Base width="100%" fontSize={14} color="#F23051" height={64}
                  style={{visibility: selectLeverage > leverageInfo.defaultVal ? '' : 'hidden'}}>
                  <Icon color="#F23051" size={16} mr={2} name="information-o" />
                  {i18n.leverageHighRiskTip || 'Your leverage is high, please be careful of the risk.'}
                </Text.Base>
              </Flex>
              <Flex mt={16}>
                <Button ml={0} mr={5} height={40} width="100%" outline bg="#fff" onClick={onClose}>
                  {i18n.cancelBtnText || 'Cancel'}
                </Button>
                <Button height={40} width="100%" bg="primary" color="#212833"
                  onClick={() => {
                    updateLeverage(selectLeverage)
                    onClose()
                  }}>
                  {i18n.confirmBtn || 'Confirm'}
                </Button>
              </Flex>
              </> : <Flex className="not-login">
                <Text.Base>{i18n.please || 'Please'}</Text.Base>
                <TextButton
                  onClick={() => {
                    window.location.href = `${LOGIN_PRURL}?callback=${window.location.href}`.replace(
                      '$locale',
                      lng
                    )
                  }}
                  color="#F0B90B"
                  mr={2}
                >
                  {i18n['tradeHistory-login'] || 'Log in'}
                </TextButton>
                <Text.Base>{i18n.or || 'or'}</Text.Base>
                <TextButton
                  onClick={() => (window.location.href = REGISTER_URL.replace('$locale', lng))}
                  color="#F0B90B"
                  mr={2}
                >
                  {i18n['tradeHistory-register'] || 'Register now'}
                </TextButton>
                <Text.Base>{i18n.toAdjust || 'to adjust'}</Text.Base>
              </Flex>
            }
          </Box>
        </MessageBoxWrap>
      </Dialog>
    ),
    [onClose, i18n, selectLeverage, maxLeverage, quoteAsset, isLogin, userNotionalValue, nationalVal, updateLeverage, lng]
  )
}
